import { render, staticRenderFns } from "./AllTagsModal.vue?vue&type=template&id=710410a2&scoped=true&"
import script from "./AllTagsModal.vue?vue&type=script&lang=js&"
export * from "./AllTagsModal.vue?vue&type=script&lang=js&"
import style0 from "./AllTagsModal.vue?vue&type=style&index=0&id=710410a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710410a2",
  null
  
)

export default component.exports